module.exports = __webpack_public_path__ + "static/media/4.fd690183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 91
// module chunks = 0